var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTagManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16857_171541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 7.99898C13.2138 7.19645 13.6659 6.46476 14.3817 6.06262C14.4672 6.00633 14.5528 5.97959 14.6383 5.92442L13.9261 4.67958L13.1852 3.43445L12.9275 3.6005C12.2087 4.01018 11.3204 4.02088 10.5913 3.62865C9.87967 3.20303 9.44821 2.44782 9.45305 1.63628C9.44854 1.53406 9.45829 1.43171 9.48203 1.33203H6.51855C6.51855 1.41506 6.54754 1.52567 6.54754 1.63628C6.54482 2.44613 6.11457 3.19805 5.40783 3.62809C4.6755 4.00632 3.79511 3.99592 3.07247 3.6005C2.98269 3.55164 2.89692 3.49613 2.81594 3.43445L2.07421 4.6793L1.33334 5.92414C1.42455 5.95943 1.51075 6.00587 1.58986 6.06233C2.30564 6.46451 2.75775 7.19618 2.78638 7.9987C2.75775 8.80121 2.30564 9.53288 1.58986 9.93506C1.50435 9.99135 1.41884 10.0181 1.33334 10.0733L2.07421 11.3181L2.81507 12.5629L3.07247 12.3975C3.79135 11.9878 4.67957 11.9771 5.4087 12.3693C6.12071 12.7945 6.55273 13.5495 6.54841 14.3611C6.55292 14.4633 6.54317 14.5657 6.51942 14.6654H9.48145C9.48145 14.5823 9.45247 14.4717 9.45247 14.3611C9.45519 13.5513 9.88543 12.7993 10.5922 12.3693C11.3248 11.9909 12.2056 12.0016 12.9284 12.3975L13.1849 12.5635L13.9258 11.3187L14.6667 10.0738C14.5755 10.0385 14.4893 9.99209 14.4101 9.93563C13.6787 9.54499 13.2132 8.8091 13.1852 7.99898ZM7.99997 10.7764C6.46586 10.7764 5.22222 9.53277 5.22222 7.99866C5.22222 6.46456 6.46586 5.22092 7.99997 5.22092C9.53408 5.22092 10.7777 6.46456 10.7777 7.99866C10.7828 8.73692 10.4918 9.44642 9.96977 9.96846C9.44773 10.4905 8.73823 10.7815 7.99997 10.7764Z",
    fill: "#7783A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16857_171541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTagManage);
export default __webpack_public_path__ + "static/media/icon_tag_manage.cce81fbb2fb1d3de87d312581edcf034.svg";
export { ForwardRef as ReactComponent };